import { render, staticRenderFns } from "./Moderation.vue?vue&type=template&id=e738fbb8&scoped=true"
import script from "./Moderation.vue?vue&type=script&lang=js"
export * from "./Moderation.vue?vue&type=script&lang=js"
import style0 from "./Moderation.vue?vue&type=style&index=0&id=e738fbb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e738fbb8",
  null
  
)

export default component.exports